import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getOtpWidgetStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    textCenter: {
      textAlign: 'center'
    },
    titleContainer: {
      marginBottom: spacing.SPACING_4
    },
    otpInputContainer: {
      marginTop: spacing.SPACING_20
    },
    rtnContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: spacing.SPACING_4
    },
    changeButton: {
      paddingHorizontal: spacing.SPACING_6,
      paddingVertical: spacing.SPACING_0
    },
    secondaryButton: {
      marginTop: spacing.SPACING_32
    },
    loaderContainer: {
      alignItems: 'center',
      paddingVertical: spacing.SPACING_74
    },
    loaderLabel: {
      marginTop: spacing.SPACING_20
    },
    calloutWidgetStyles: {
      marginTop: spacing.SPACING_20
    },
    btnWidgetStyles: {
      marginTop: 40
    }
  });
};